import {reqWithToken} from './requestHelper';

export async function exportExcel(params){
    return (await reqWithToken('api/pebooking/export/forms', {
        params,
        responseType: 'blob'
    })).data;
}